// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IClaimTransferAccountsResponse,
} from '../models/index';
import {
    IClaimTransferAccountsResponseFromJSON,
    IClaimTransferAccountsResponseToJSON,
} from '../models/index';

export interface GetTransferAccountsByClaimIdRequest {
    claimId: number;
}

/**
 * ClaimTransferControllerApi - interface
 * 
 * @export
 * @interface ClaimTransferControllerApiInterface
 */
export interface ClaimTransferControllerApiInterface {
    /**
     * 
     * @param {number} claimId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimTransferControllerApiInterface
     */
    getTransferAccountsByClaimIdRaw(requestParameters: GetTransferAccountsByClaimIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimTransferAccountsResponse>>;

    /**
     */
    getTransferAccountsByClaimId(requestParameters: GetTransferAccountsByClaimIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimTransferAccountsResponse>;

}

/**
 * 
 */
export class ClaimTransferControllerApi extends runtime.BaseAPI implements ClaimTransferControllerApiInterface {

    /**
     */
    async getTransferAccountsByClaimIdRaw(requestParameters: GetTransferAccountsByClaimIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimTransferAccountsResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getTransferAccountsByClaimId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/transfer/claims/{claim-id}/accounts`;
        urlPath = urlPath.replace(`{${"claim-id"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimTransferAccountsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getTransferAccountsByClaimId(requestParameters: GetTransferAccountsByClaimIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimTransferAccountsResponse> {
        const response = await this.getTransferAccountsByClaimIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
